/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {AuthService, I18nService, OLD_PASSWORD_INVALID, ThirdPartyService, UPDATE_SUCCESS, UserService} from '../../_services/services';
import {MustMatch} from '../../_validators/must-match.validator';
import {Helpers} from '../../helpers';
import {ToastrService} from 'ngx-toastr';
import {HttpErrorResponse} from '@angular/common/http';
import {PRE_CONDITION_FAILED} from '../../_enums/requests';
import {DialogHelper} from '../../_helpers/dialog-helper';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VIEW CHILD                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @ViewChild('passwordForm', { static: true }) passwordForm: NgForm;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS GROUPS                                                                                          ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public passwordFG: FormGroup;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC FUNCTIONS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private authService: AuthService,
    private dialogHelper: DialogHelper,
    private formBuilder: FormBuilder,
    private i18n: I18nService,
    private userService: UserService,
    private thirdPartyService: ThirdPartyService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
    this.passwordFG = this.formBuilder.group({
      oldPassword: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirm: [null, [Validators.required]]
    }, {
      validator: MustMatch('password', 'confirm')
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PASSWORD FORM CONTROLS                                                                                   ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get oldPassword(): AbstractControl {
    return this.passwordFG.get('oldPassword');
  }

  get confirm(): AbstractControl {
    return this.passwordFG.get('confirm');
  }

  get password(): AbstractControl {
    return this.passwordFG.get('password');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS SUBMITS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  passwordFormSubmit() {
    if (this.passwordFG.valid) {
      Helpers.setLoading(true);

      this.userService.updatePassword(this.oldPassword.value, this.password.value).subscribe(() => {
        Helpers.setLoading(false);
        this.passwordFG.reset();

        if (this.passwordForm) {
          this.passwordForm.resetForm();
        }

        this.toastr.success(this.i18n.get(UPDATE_SUCCESS));
      }, (err) => {
        Helpers.setLoading(false);

        if (PRE_CONDITION_FAILED === err.status) {
          this.toastr.warning(err.error ? err.error : this.i18n.get(OLD_PASSWORD_INVALID));
        } else {
          this.handleError(err);
        }
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
